import { GetStaticProps } from 'next'
import { pageUtil } from '@/services/api/pageUtil'

export { default } from '@/components/pages/landing/LandingPage'

export const getStaticProps: GetStaticProps = async () =>
  pageUtil.getLandingPageProps()
